import { API_TYPE } from '@umu/umu-fetch';

const BasePath = '/napi/private-message';

export const PrivateMessageAPI = {
    PRIVATE_MSG_CHAT_LIST: {
        url: `${BasePath}/list`,
        type: API_TYPE.GET,
    },
    PRIVATE_MSG_CHAT_HIDE: {
        url: `${BasePath}/hidden`,
        type: API_TYPE.POST,
    },
    PRIVATE_MSG_CHAT_READ: {
        url: `${BasePath}/read`,
        type: API_TYPE.POST,
    },
    PRIVATE_MSG_SEND: {
        url: `${BasePath}/messages/send`,
        type: API_TYPE.POST,
    },
    PRIVATE_MSG_DELETE: {
        url: `${BasePath}/messages/delete`,
        type: API_TYPE.POST,
    },
    PRIVATE_MSG_LIST: {
        url: `${BasePath}/messages/list`,
        type: API_TYPE.GET,
    },
};
